// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"67cfad0b","703":"336f4f37","787":"8513ce89"}[chunkId] + ".chunk.js";
};